import { useEffect, useState } from 'react';
import { BASEURL } from '../../config';
import ReactPlayer from "react-player";
import PlayerYoutube from './playerYT';

function PlayerCourseHere({ DefaultVideoTitle, DefaultVideoId }) {
    const [RunTimer, setRunTimer] = useState(0);
    const [IsLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setIsLoaded(true);
        }, 786);
        // Clean up the event listener on component unmount
        const UpdateDone = setInterval(() => {
            setRunTimer(10);
        }, 5000);
        return () => {
            clearInterval(UpdateDone);
        };
    }, [DefaultVideoId]);

    return (
        <>
            <section>
                <div id="VideoPlayerID" style={{ position: 'relative' }}>
                    <div className="RYDetailPlayer">
                        <b
                            className="RYDetailPlayerTitle"
                            style={{ display: RunTimer > 5 ? 'none' : '' }}
                        >
                            {DefaultVideoTitle}
                        </b>
                        <div id="video-container" style={{ position: 'relative' }}>
                            <div id="overlay"></div>
                            <div
                                style={{
                                    position: 'relative',
                                }}
                            >
                                <PlayerYoutube
                                    DefaultVideoId={`https://www.youtube.com/watch?v=${DefaultVideoId}`}
                                    DefaultVideoTitle="Rahul Yadav"
                                />
                            </div>
                            {IsLoaded ? (
                                ''
                            ) : (
                                <div className="text-center text-info">
                                    <img
                                        alt="Video is Loading, If video not loaded in sometime, Try refreshing the page or try after sometime."
                                        src={`${BASEURL}loader.gif`}
                                        style={{
                                            margin: '20px auto',
                                            maxWidth: '110px',
                                        }}
                                    />
                                    {/* Video is Loading, If video not loaded in sometime, Try refreshing the page or try after sometime. */}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default PlayerCourseHere;
